import React from 'react';

interface Props {
    showLoader:boolean
}

const PreLoader = ({showLoader}:Props) => {
    return (
        showLoader
        ?
          <div id="global-loader">
            <div className="page-loader"></div>
          </div>
        :
          <>
          </>
      );
}
export default PreLoader;